//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryUserSimCards, queryDeviceSimCard } from '@/api/simcard'

export default {
  name: 'SimCardList',
  data () {
    return {
      keyword: '',
      list: [],
      total: 0,
      normalCnt: 0,
      expiringCnt: 0,
      expiredCnt: 0,
      loading: false,
      refreshing: false,
      imgArr: []
    }
  },
  computed: {
    filteredList () {
      if (!this.keyword) {
        return this.list
      }
      let kw = this.keyword.toLowerCase().trim()
      return this.list.filter(item => {
        let nameMatch = item.devicename && item.devicename.toLowerCase().includes(kw)
        let imeiMatch = item.deviceid && item.deviceid.toLowerCase().includes(kw)
        let phoneMatch = item.devicephone && item.devicephone.includes(kw)
        let iccidMatch = item.simcard && item.simcard.iccid && item.simcard.iccid.toLowerCase().includes(kw)
        let simPhoneMatch = item.simcard && item.simcard.phonenum && item.simcard.phonenum.includes(kw)
        return nameMatch || imeiMatch || phoneMatch || iccidMatch || simPhoneMatch
      })
    }
  },
  created () {
    let token = this.$route.query.token
    if (token) {
      this.$store.commit('set_token', token)
    }
    if (this.common && this.common.getDeviceImg) {
      this.imgArr = this.common.getDeviceImg()
    }
    // 打开页面时自动请求并向运营商刷新流量卡最新状态
    this.loadData(true, false)
  },
  mounted () {
    document.title = '我的流量卡'
  },
  methods: {
    loadData (force = true, isManual = false) {
      let token = this.$route.query.token || this.$store.getters.get_token
      if (this.$route.query.token) {
        this.$store.commit('set_token', this.$route.query.token)
      }
      if (!token) {
        this.$toast('未检测到登录 Token，请先登录')
        this.loading = false
        this.refreshing = false
        return
      }
      this.loading = true
      if (isManual) {
        this.$toast.loading({
          message: '正在向运营商同步数据...',
          forbidClick: false,
          duration: 2500
        })
      }
      let params = {}
      if (force) {
        params.refresh = 1
      }
      queryUserSimCards(params).then(res => {
        this.loading = false
        this.refreshing = false
        if (res && res.data) {
          let rawList = res.data.list || []
          this.list = rawList.filter(item => !this.isNbOrNon4G(item.dtype))
          this.total = this.list.length
          this.updateSummaryCounts()
          if (isManual) {
            this.$toast.success('刷新成功')
          }
          // 兜底：若仍有个别卡处于待查询状态且非自有卡，在后台异步重试查询
          this.autoRefreshUnknownCards()
        }
      }).catch(err => {
        this.loading = false
        this.refreshing = false
        console.error('queryUserSimCards error', err)
        if (isManual) {
          this.$toast.fail('刷新失败')
        }
      })
    },
    onPullRefresh () {
      this.loadData(true, false)
    },
    handleManualRefresh () {
      this.loadData(true, true)
    },
    autoRefreshUnknownCards () {
      this.list.forEach(item => {
        if (item.expire_status === 'unknown' && item.simcard && item.simcard.iccid && item.simcard.source_type !== 1) {
          queryDeviceSimCard({ did: item.did, iccid: item.simcard.iccid, refresh: true }).then(res => {
            if (res && res.data && res.data.simcard) {
              this.$set(item, 'simcard', res.data.simcard)
              this.$set(item, 'expire_status', res.data.simcard.expire_status)
              this.$set(item, 'days_left', res.data.simcard.days_left)
              this.updateSummaryCounts()
            }
          }).catch(() => {})
        }
      })
    },
    updateSummaryCounts () {
      this.normalCnt = this.list.filter(item => item.expire_status === 'normal').length
      this.expiringCnt = this.list.filter(item => item.expire_status === 'expiring').length
      this.expiredCnt = this.list.filter(item => item.expire_status === 'expired').length
    },
    getPhoneNum (item) {
      if (item.simcard && item.simcard.phonenum) {
        return item.simcard.phonenum
      }
      return item.devicephone || '未记录'
    },
    getValidDate (item) {
      if (item.simcard && item.simcard.source_type === 1) {
        return '自备卡(自行维护)'
      }
      if (item.simcard && item.simcard.validdate) {
        return item.simcard.validdate
      }
      return '未查询到有效时间'
    },
    getBadgeClass (item) {
      if (item.simcard && item.simcard.source_type === 1) {
        return 'badge-custom'
      }
      switch (item.expire_status) {
        case 'normal':
          return 'badge-normal'
        case 'expiring':
          return 'badge-expiring'
        case 'expired':
          return 'badge-expired'
        default:
          return 'badge-unknown'
      }
    },
    getBadgeText (item) {
      if (item.simcard && item.simcard.source_type === 1) {
        return '自备卡'
      }
      switch (item.expire_status) {
        case 'normal':
          return '正常'
        case 'expiring':
          return `剩${item.days_left}天到期`
        case 'expired':
          return '已过期'
        case 'unknown':
          return '待查询'
        default:
          return '无流量卡'
      }
    },
    refreshCard (item) {
      let iccid = item.simcard ? item.simcard.iccid : ''
      this.$toast.loading({
        message: '正在向运营商刷新...',
        forbidClick: true,
        duration: 2000
      })
      queryDeviceSimCard({ did: item.did, iccid: iccid, refresh: true }).then(res => {
        if (res && res.data && res.data.simcard) {
          this.$set(item, 'simcard', res.data.simcard)
          this.$set(item, 'expire_status', res.data.simcard.expire_status)
          this.$set(item, 'days_left', res.data.simcard.days_left)
          this.updateSummaryCounts()
          this.$toast.success('刷新成功')
        } else {
          this.$toast.fail('未查询到更新')
        }
      }).catch(err => {
        console.error('refreshCard err', err)
        this.$toast.fail('刷新失败')
      })
    },
    handleRecharge (item) {
      this.$toast('流量卡在线续费功能即将开放，敬请期待！')
    },
    isNbOrNon4G (dtype) {
      if (this.common && this.common.isNbOrNon4G) {
        return this.common.isNbOrNon4G(dtype)
      }
      return false
    },
    getDeviceIcon (dtype) {
      if (!this.imgArr || this.imgArr.length === 0) {
        if (this.common && this.common.getDeviceImg) {
          this.imgArr = this.common.getDeviceImg()
        }
      }
      let key = parseInt(dtype)
      let defaultImg = 'static/newDeviceIcon/index_default.png'
      if (this.imgArr && this.imgArr.length > 0) {
        for (let i = 0; i < this.imgArr.length; i++) {
          if (this.imgArr[i].dtype === key) {
            return this.imgArr[i].imgUrl
          }
        }
        // 特征品类兜底匹配
        if ((key >= 310 && key <= 313) || (key >= 350 && key <= 353)) {
          return 'static/newDeviceIcon/index_shoubiao.png'
        }
        if (key === 601 || key === 613) {
          return 'static/newDeviceIcon/index_lock.png'
        }
        return this.imgArr[this.imgArr.length - 1].imgUrl || defaultImg
      }
      return defaultImg
    },
    getDeviceTypeName (dtype) {
      let key = parseInt(dtype)
      const typeMap = {
        300: '2G手表',
        301: '车载定位器',
        310: '4G健康手表',
        311: '4G健康手表',
        312: '4G健康手表',
        313: '4G健康手表',
        330: '4G手表',
        331: '4G拉绳报警器',
        332: '4G胸卡定位',
        350: '防拆手表',
        351: '防拆手表',
        352: '防拆手表',
        353: '防拆手表',
        400: '智能门锁',
        401: '智能门锁',
        501: '一氧化碳',
        502: '燃气报警器',
        503: '灭火器压力表',
        504: '门磁报警器',
        505: 'SOS求救按钮',
        506: '烟雾报警器',
        507: 'SOS按钮',
        508: '门磁报警器',
        509: '智能门锁',
        510: '水浸报警器',
        511: '断电监测器',
        512: '烟感报警器',
        533: '4G传感器',
        534: '4G传感器',
        536: '4G传感器',
        537: '4G-SOS按钮',
        538: '4G门磁',
        539: '4G水浸',
        540: '4G烟感',
        541: '4G燃气',
        542: '4G一氧化碳',
        543: '4G门磁',
        544: '4G水浸',
        545: '4G红外',
        546: '4G水压',
        601: '4G智能门锁',
        613: '4G智能门锁',
        700: '智能网关',
        701: '拉绳网关',
        750: '4G睡眠带',
        751: '4G温湿度',
        752: '4G感应雷达',
        753: '4G温湿度',
        754: '4G健康雷达',
        780: '4G跌倒雷达',
        800: '4G报警网关',
        850: '4G血压计',
        851: '4G血糖仪',
        852: '4G健康仪',
        901: '4G终端',
        902: '4G拉绳报警器',
        903: '4G终端',
        904: '4G断电报警器',
        905: '4G断电报警器',
        906: 'UPS设备',
        920: '4G语音呼叫器'
      }
      return typeMap[key] || ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/more/simCardList.vue